import { CompanyNameFastResolver } from './../businesses/services/business.resolver.service';
import { Route } from '@angular/router';
import { AuthGuard } from './../../_guards/index';
import { ContactComponent } from './contact.component';
import {
    ContactEditResolver,
    ContactTypeResolver,
    FunctionListResolver,
    CountryCodeListResolver,
    CustomerContactsWithLoginResolver,
    CustomerContactsWithResolver,
} from './services/contact.resolver.service';
import {
    CustomerContactLoginComponent,
    CustomerContactComponent,
    ContactListComponent,
    ContactEditComponent
} from './components/index';

export const contactRoutes: Route[] = [
    {
        path: 'contact',
        component: ContactComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'list',
                component: ContactListComponent,
                canActivate: [AuthGuard],
                children: [
                    {
                        path: 'login',
                        component: CustomerContactLoginComponent,
                        resolve: {
                            list: CustomerContactsWithLoginResolver,
                            function: FunctionListResolver,
                        }
                    },

                    {
                        path: 'contact',
                        component: CustomerContactComponent,
                        resolve: {
                            list: CustomerContactsWithResolver,
                            function: FunctionListResolver,
                            business: CompanyNameFastResolver
                        }
                    }
                ]
            },
            {
                path: 'edit/:cid',
                component: ContactEditComponent,
                canActivate: [AuthGuard],
                resolve: {
                    edit: ContactEditResolver,
                    contactType: ContactTypeResolver,
                    function: FunctionListResolver,
                    countryCode: CountryCodeListResolver
                }
            }
        ]
    }
];
